import { TypeHighlightedText } from '~/types/contentful'

export const HighlightedText = ({
  data,
}: {
  data: TypeHighlightedText<'WITHOUT_UNRESOLVABLE_LINKS', string>
}) => {
  const { fields } = data
  const { title, description } = fields

  return (
    <div className="flex flex-col items-start self-stretch border-l-2 border-blue-30 mb-6 gap-2 pl-8">
      <span className="text-s">{title}</span>
      <p className="text-xs text-neutral-60">{description}</p>
    </div>
  )
}
